import { render } from "./marchHeatmpLive.vue?vue&type=template&id=f21c9520&scoped=true"
import script from "./marchHeatmpLive.vue?vue&type=script&lang=js"
export * from "./marchHeatmpLive.vue?vue&type=script&lang=js"

import "./marchHeatmpLive.vue?vue&type=style&index=0&id=f21c9520&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f21c9520"]])

export default __exports__